const routes = [
    {
        path: "/customer/refunds",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            permission:'customerrefund_index'
        },
    }
];

export default routes;
